import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { ArrowLeft, Share2, Info, ChevronLeft, ChevronRight, MapPin, Calendar } from 'lucide-react';
import { getShareLink } from '../utils/links';

const PAST_BURIALS = [
  { id: 'pb-1', name: 'Haji Abdullah bin Osman',       date: '14 Mar 2026, 2:30 PM',  location: 'Pusara Aman, Blk 15, Plot 102' },
  { id: 'pb-2', name: 'Hajjah Fatimah binti Ali',       date: '22 Nov 2024, 10:00 AM', location: 'Pusara Aman, Blk 12, Plot 45'  },
  { id: 'pb-3', name: 'Muhammad Ridzuan bin Hassan',    date: '05 Jun 2023, 4:15 PM',  location: 'Pusara Aman, Blk 9, Plot 330'  },
  { id: 'pb-4', name: 'Siti Nurhaliza binti Ibrahim',   date: '18 Jan 2022, 11:30 AM', location: 'Pusara Aman, Blk 7, Plot 88'   },
  { id: 'pb-5', name: 'Abdul Rahman bin Yusof',         date: '30 Sep 2021, 5:00 PM',  location: 'Pusara Aman, Blk 4, Plot 12'   }
];

export default function MyPastBurials({ onBack, onOpenDetail }) {
  const handleShare = (entry) => {
    const slug = entry.name.toLowerCase().replace(/\s+/g, '-');
    const link = getShareLink('casket-past', { slug });
    const text = encodeURIComponent(
      `Assalamualaikum,\n\nIn remembrance of the late ${entry.name} — laid to rest on ${entry.date} at ${entry.location}.\n\nView the service tracker and details here:\n${link}\n\nAl-Fatihah.`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="min-h-screen bg-muted/20">
      <header className="bg-card border-b sticky top-0 z-10 shadow-sm">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Button variant="ghost" onClick={onBack} className="gap-2" data-testid="past-burials-back">
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
          <h1 className="text-lg sm:text-xl font-semibold">My Past Burials</h1>
          <div className="w-16" />
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 py-6 space-y-4">
        {PAST_BURIALS.map((entry) => (
          <Card key={entry.id} data-testid={`past-burial-${entry.id}`} className="border">
            <CardContent className="p-4 sm:p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-base sm:text-lg leading-tight">
                    {entry.name}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-1.5 flex items-center gap-1.5">
                    <Calendar className="h-3.5 w-3.5 flex-shrink-0" />
                    {entry.date}
                  </p>
                  <p className="text-sm text-muted-foreground mt-1 flex items-start gap-1.5">
                    <MapPin className="h-3.5 w-3.5 flex-shrink-0 mt-0.5" />
                    <span>{entry.location}</span>
                  </p>
                </div>
                <div className="flex flex-col gap-2 flex-shrink-0">
                  <button
                    data-testid={`share-${entry.id}`}
                    onClick={() => handleShare(entry)}
                    aria-label="Share tracker link"
                    className="w-9 h-9 rounded-full border hover:bg-primary/5 hover:border-primary transition-colors flex items-center justify-center"
                  >
                    <Share2 className="h-4 w-4 text-primary" />
                  </button>
                  <button
                    data-testid={`info-${entry.id}`}
                    onClick={() => onOpenDetail(entry)}
                    aria-label="View burial summary"
                    className="w-9 h-9 rounded-full border hover:bg-primary/5 hover:border-primary transition-colors flex items-center justify-center"
                  >
                    <Info className="h-4 w-4 text-primary" />
                  </button>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}

        {/* Pagination (dummy) */}
        <nav
          data-testid="past-burials-pagination"
          className="flex items-center justify-center gap-1 pt-4 pb-6 text-sm"
        >
          <button className="px-2 py-1.5 rounded-md hover:bg-muted flex items-center gap-1 text-muted-foreground">
            <ChevronLeft className="h-4 w-4" />
            Prev
          </button>
          {[1, 2, 3, 4].map((n) => (
            <button
              key={n}
              className={`w-8 h-8 rounded-md ${n === 1 ? 'bg-primary text-primary-foreground font-semibold' : 'hover:bg-muted text-foreground'}`}
            >
              {n}
            </button>
          ))}
          <button className="px-2 py-1.5 rounded-md hover:bg-muted flex items-center gap-1 text-muted-foreground">
            Next
            <ChevronRight className="h-4 w-4" />
          </button>
        </nav>
      </div>
    </div>
  );
}
